/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilekindorganizer2Inputs */

const en_profilekindorganizer2 = /** @type {(inputs: Profilekindorganizer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizer`)
};

const de_profilekindorganizer2 = /** @type {(inputs: Profilekindorganizer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstalter`)
};

/**
* | output |
* | --- |
* | "Organizer" |
*
* @param {Profilekindorganizer2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilekindorganizer2 = /** @type {((inputs?: Profilekindorganizer2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilekindorganizer2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilekindorganizer2(inputs)
	return de_profilekindorganizer2(inputs)
});
export { profilekindorganizer2 as "profileKindOrganizer" }